import React from "react";
import {
  Box,
  IconButton,
  Grid2 as Grid,
  Card,
  LinearProgress,
  Typography,
} from "@mui/material";
import ArrowForwardOutlinedIcon from "@mui/icons-material/ArrowForwardOutlined";
import { useClientContext } from "../context/ClientContext";
import { useState, useEffect } from "react";
import { relationshipRevenueData } from "../assets/relationshipRevenue";
import { clientGroups } from "../assets/clientData";
import { formatCurrency } from "../utils/helper";

const RelationshipRevenueCard = ({ setShowTable }) => {
  const { clientName, clientGroup } = useClientContext();
  const [data, setData] = useState(null);

  const handleTableView = () => {
    setShowTable(true);
  };

  // const [revenues, setRevenues] = useState({
  //   year: "FY25",
  //   total: "950",
  //   lists: [
  //     { name: "Asset NII", target: 100, current: 90, gap: 10 },
  //     { name: "Liabilities  NII", target: 100, current: 90, gap: 10 },
  //     { name: "Fee Income", target: 1, current: 0.8, gap: 10 },
  //   ],
  // });

  const [revenues, setRevenues] = useState({
    year: "",
    total: "",
    lists: [
      { name: "Asset NII", target: "", current: "", gap: "" },
      { name: "Liabilities  NII", target: "", current: "", gap: "" },
      { name: "Fee Income", target: "", current: "", gap: "" },
    ],
  });

  useEffect(() => {
    // Filter data based on selected client and group
    if (clientName && clientGroup) {
      const filteredData = relationshipRevenueData.filter(
        (data) =>
          data.company_name === clientName &&
          data.group_company ===
            clientGroups.find((group) => group.group_name === clientGroup)
              ?.label
      )[0];

      if (filteredData) {
        setRevenues({
          year: `FY${filteredData.fy.toString().slice(-2)}`,
          total: formatCurrency(filteredData.total_income),
          lists: [
            {
              name: "Asset NII",
              target:
                filteredData.asset_nii_target === 0
                  ? 0
                  : filteredData.asset_nii_target || "...",
              current:
                filteredData.asset_nii === 0
                  ? 0
                  : filteredData.asset_nii || "...",
              gap:
                filteredData.asset_nii_gap === 0
                  ? 0
                  : filteredData.asset_nii_gap || "...",
            },
            {
              name: "Liabilities NII",
              target:
                filteredData.liabilities_nii_target === 0
                  ? 0
                  : filteredData.liabilities_nii_target || "...",
              current:
                filteredData.liabilities_nii === 0
                  ? 0
                  : filteredData.liabilities_nii || "...",
              gap:
                filteredData.liabilities_nii_gap === 0
                  ? 0
                  : filteredData.liabilities_nii_gap || "...",
            },
            {
              name: "Fee Income",
              target:
                filteredData.fee_income_target === 0
                  ? 0
                  : filteredData.fee_income_target || "...",
              current:
                filteredData.fee_income === 0 ? 0 : filteredData.fee_income,
              gap:
                filteredData.fee_income_gap === 0
                  ? 0
                  : filteredData.fee_income_gap || "...",
            },
          ],
        });
      }
    }
  }, [clientName, clientGroup]);

  return (
    <Box
      className="rounded-md py-1 px-4"
      style={{
        boxShadow: "0px 2px 20px rgba(0, 0, 0, 0.1)",
        height: "60vh", // Fixed height
        overflowY: "scroll", // Enable vertical scrolling
      }}
    >
      {/* Header */}
      <div className="flex justify-between items-center">
        <div className="text-main font-bold text-left text-xs">
          Relationship Revenue
        </div>
        <IconButton
          aria-label="<>"
          onClick={handleTableView}
          sx={{ height: 24, width: 24 }}
        >
          <ArrowForwardOutlinedIcon sx={{ fontSize: 16 }} />
        </IconButton>
      </div>

      <div className="">
        {/* Total Income */}
        <Grid container gap={2} my={1} fontWeight={"bold"}>
          <Grid item>{`Total Income for ${revenues.year}`}</Grid>
          <div item className="text-main">
            {`${revenues.total} IDR`}
          </div>
        </Grid>

        {/* Content Rows */}
        {revenues.lists.map((list, key) => (
          <Box className="my-2" key={key}>
            <Card sx={{ background: "#eeeeee" }}>
              <Box className="px-2 py-1 grid gap-1 text-gray-600 text-[12px]">
                <div className=" font-bold">{list.name}</div>
                <div>
                  Target (IDR) :{" "}
                  <span className="text-main">
                    {formatCurrency(list.target)} IDR
                  </span>
                </div>
                <div>
                  Current Value (IDR) :{" "}
                  <span className="text-main">
                    {formatCurrency(list.current)} IDR
                  </span>
                </div>

                <Box sx={{ display: "flex", alignItems: "center" }}>
                  <Box sx={{ width: "100%", mr: 1 }}>
                    <LinearProgress
                      variant="determinate"
                      value={(list.current / list.target) * 100 || 0}
                      sx={{ height: 10 }}
                    />
                  </Box>
                  <Box sx={{ minWidth: 35 }}>
                    <div className="text-main">{`${(
                      (list.current / list.target) * 100 || 0
                    ).toFixed(1)}%`}</div>
                  </Box>
                </Box>
                <div>
                  Gap (IDR) :{" "}
                  <span className="text-main">
                    {formatCurrency(list.gap)} IDR
                  </span>
                </div>
              </Box>
            </Card>
          </Box>
        ))}
      </div>
    </Box>
  );
};

export default RelationshipRevenueCard;
